import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { Field } from 'redux-form';
import { getEntities } from 'dash-front/selectors';
import { fetchAllTournaments } from 'dash-front/actions/tournaments';
import { STORE_KEYS } from 'dash-front/constants';
import RFSelect from './RFSelect';

const TournamentPicker = ({ tournaments = [], name = 'tournamentId' }) => {
    return (
        <Field
            name={name}
            ignoreCase
            matchProp={'any'}
            options={tournaments}
            labelKey={'name'}
            valueKey={'id'}
            placeholder={'Tournament (league)'}
            component={RFSelect}
        />
    );
};

const mapStateToProps = state => ({ tournaments: getEntities(state)[STORE_KEYS.TOURNAMENTS] });

export default compose(
    connect(mapStateToProps),
    lifecycle({
        componentDidMount() {
            this.props.dispatch(fetchAllTournaments());
        }
    })
)(TournamentPicker);



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/Form/pickers/TournamentPicker.js
 **/